import React, { useState, useEffect } from 'react';
import { useAccount, useSwitchChain } from 'wagmi';
import { bsc } from 'wagmi/chains';
import ClaimPage from './components/ClaimPage';
import SwapPage from './components/SwapPage';

function App() {
  const [activeTab, setActiveTab] = useState('claim');
  const { chain } = useAccount();
  const { switchChain } = useSwitchChain();

  // Memaksa pindah ke BSC jika user menggunakan browser DApp mobile (Bitget, dll)
  useEffect(() => {
    if (chain && chain.id !== bsc.id && switchChain) {
      switchChain({ chainId: bsc.id });
    }
  }, [chain, switchChain]);

  return (
    <div className="app-wrapper">
      {activeTab === 'claim' ? (
        <ClaimPage navigateToSwap={() => setActiveTab('swap')} />
      ) : (
        <SwapPage navigateToClaim={() => setActiveTab('claim')} />
      )}
    </div>
  );
}

export default App;